import { getEnvironment } from "@util/constant";

/** Helper function to get the redirect url of BT */
export const getRedirectEditionUrl = (): Record<string, string> => {
  const env = getEnvironment();

  switch (env) {
    case "staging-env":
      return {
        bt: "https://uat.businesstimes.com.sg/?region=sg",
        bti: "https://uat.businesstimesintl.com/?region=nonsg",
      };

    case "production-env":
    default:
      return {
        bt: "https://www.businesstimes.com.sg/?region=sg",
        bti: "https://www.businesstimesintl.com/?region=nonsg",
      };
  }
};
